import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Button } from '@chakra-ui/react';
//
import { contactUs } from '../../state/actions/customers/customers';

function index() {
  const dispatch = useDispatch();

  const customersReducer = useSelector((state) => state.customersReducer);

  const validationSchema = Yup.object({
    email: Yup.string().email('Invalid email address').required('Required'),
    name: Yup.string().required('Required'),
    subject: Yup.string().required('Required'),
    message: Yup.string().required('Required'),
  });

  // handle submit
  function handleSubmit(values, { resetForm }) {
    dispatch(contactUs(values.name, values.email, values.subject, values.message));
    // todo: reset form after successful submission
    resetForm();
  }
  return (
    <div>
      <section className="bg-gradient-to-b from-gray-50 to-white text-gray-700 body-font relative">
        <div className="container px-5 py-24 mx-auto">
          <div className="flex flex-col text-center w-full mb-12">
            <h1 className="">Contact Us</h1>
            <p className="lg:w-2/3 mx-auto leading-relaxed text-base">We are here to help you</p>
          </div>
          <Formik
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            initialValues={{
              email: '',
              name: '',
              subject: '',
              message: '',
            }}
          >
            {({ errors, handleSubmit, handleChange, handleBlur, values, touched }) => (
              <form onSubmit={handleSubmit} className="lg:w-1/2 md:w-2/3 mx-auto">
                <div className="flex flex-wrap -m-2">
                  <div className="p-2 w-full md:w-1/2">
                    <div className="relative">
                      <label htmlFor="name" className="leading-7  ">
                        Name
                      </label>
                      <input
                        // placeholder="Bob Collymore"
                        // id="name"
                        name="name"
                        type="name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.name}
                        className={`form-input ${
                          touched.name && errors.name ? 'border-red-500' : ''
                        }`}
                      />
                      {touched.name && errors.name ? (
                        <p className="text-red-600">{errors.name}</p>
                      ) : null}
                    </div>
                  </div>

                  <div className="p-2 w-full md:w-1/2">
                    <div className="relative">
                      <label htmlFor="email" className="leading-7  ">
                        Email address
                      </label>
                      <input
                        // placeholder="bobcollymore@saf.com"
                        // id="email"
                        name="email"
                        type="email"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.email}
                        className={`form-input ${
                          touched.email && errors.email ? 'border-red-500' : ''
                        }`}
                      />
                      {touched.email && errors.email ? (
                        <p className="text-red-600">{errors.email}</p>
                      ) : null}
                    </div>
                  </div>
                  <div className="p-2 w-full">
                    <div className="relative">
                      <label htmlFor="subject" className="leading-7  ">
                        Subject
                      </label>
                      <input
                        placeholder=""
                        // id="subject"
                        name="subject"
                        type="subject"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.subject}
                        className={`form-input ${
                          touched.subject && errors.subject ? 'border-red-500' : ''
                        }`}
                      />
                      {touched.subject && errors.subject ? (
                        <p className="text-red-600">{errors.subject}</p>
                      ) : null}
                    </div>
                  </div>
                  <div className="p-2 w-full">
                    <div className="relative">
                      <label htmlFor="message" className="leading-7  ">
                        Message
                      </label>

                      <textarea
                        placeholder=""
                        // id="message"
                        name="message"
                        type="message"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.message}
                        className={`form-text-area ${
                          touched.message && errors.message ? 'border-red-500' : ''
                        }`}
                      />
                      {touched.message && errors.message ? (
                        <p className="text-red-600">{errors.message}</p>
                      ) : null}
                    </div>
                  </div>
                  <div className="my-4 mx-2 w-full">
                    <Button
                      type="submit"
                      className="analytics-contact-us-button-submit "
                      colorScheme="brand"
                      isLoading={customersReducer.contactUsLoading}
                      isDisabled={customersReducer.contactUsLoading}
                      loadingText="Loading..."
                      borderRadius="0"
                    >
                      Contact us
                    </Button>
                  </div>
                  <div className="p-2 w-full pt-8 mt-8 border-t border-gray-200 text-center">
                    <p className="leading-normal my-5">
                      <a className="text-indigo-500" href="mailto:info@shulesuite.com">
                        info@shulesuite.com
                      </a>
                    </p>
                    <span className="inline-flex">
                      <a className="">
                        <svg
                          fill="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          className="w-5 h-5"
                          viewBox="0 0 24 24"
                        >
                          <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
                        </svg>
                      </a>
                      <a className="ml-4 ">
                        <svg
                          fill="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          className="w-5 h-5"
                          viewBox="0 0 24 24"
                        >
                          <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" />
                        </svg>
                      </a>
                    </span>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </section>
    </div>
  );
}

export default index;
